export default __webpack_public_path__ + "static/media/botty-customize.a6b2b55f.svg";